export default __webpack_public_path__ + "static/media/join-btn-icon.f4587160.svg";